import jwt from 'jwt-decode'
import axios from 'axios'

export const TokenStatus = () => {
    if (typeof localStorage.getItem("token") !== 'undefined'
        && localStorage.getItem("token") !== ''
        && localStorage.getItem("token") !== null) {
        return true
    }
    return false
}

export const CheckIsAdmin = () => {
    if (TokenStatus) {
        if (typeof localStorage.getItem("userInfo") !== "undefined"
            && localStorage.getItem("userInfo") !== ""
            && localStorage.getItem("userInfo") !== null
            && jwt(localStorage.getItem("token")).Roles) {
            return true
        }
    }
    return false
}

export const ReturnToken = () => {
    if (TokenStatus) {
        if (typeof localStorage.getItem("token") !== 'undefined'
            && localStorage.getItem("token") !== ""
            && localStorage.getItem("token") !== null) {
            return localStorage.getItem("token")
        }
    }
    return ''
}

export const ReturnUserInfos = () => {
    if (TokenStatus) {
        if (typeof localStorage.getItem("token") !== 'undefined'
            && localStorage.getItem("token") !== ""
            && localStorage.getItem("token") !== null) {
            if (typeof localStorage.getItem("userInfo") !== 'undefined'
                && localStorage.getItem("userInfo") !== ""
                && localStorage.getItem("userInfo") !== null) {
                let userInfos = JSON.parse(localStorage.getItem("userInfo"))
                return userInfos
            }
        }
    }
    return []
}

export const execAuthPostAxios = (url, type, formData, successMSG) => {
    try {
        if (TokenStatus()) {
            axios.post(url, formData, {
                headers: {
                    Authorization: `Bearer ` + ReturnToken(),
                    'content-type': type
                }
            }).then((response) => {
                if (response.data.status === "ok") {
                    return { status: true, message: successMSG }
                }
                else {
                    return { status: false, message: 'خطا در ارسال اطلاعات' }
                }
            }).catch(function (error) {
                return { status: false, message: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.' }
            })
        }
        else {
            return { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
        }
    } catch (error) {
        return {
            status: false, message: error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        }
    }
}